@if (levelName) {
  <span [class]="levelName | lowercase">
  {{ levelName }} VIP
</span>
} @else {
  <div class="become">{{ 't.become-vip' | translate }}</div>
}
